import api from '../../utils/fetcher';

/**
 * Appels de la page « Users projets » : /projects/<projet>/<chemin> sur le serveur du tracker, qui relaie vers l'API
 * d'administration du projet (voir routes/ProjectRoutes.js). Erreur → exception avec le message du serveur.
 */
export async function call(method, url, data) {
    let res;
    try {
        res = await api.request({ method, url, ...(method === 'get' ? { params: data } : { data }) });
    } catch (err) {
        const msg = err.response?.data?.error || err.response?.data?.message || (err.response ? `Erreur ${err.response.status}` : 'Serveur du tracker injoignable');
        throw new Error(msg);
    }
    // page HTML au lieu de JSON : ce serveur n'a pas la route (mauvaise REACT_APP_API_URL dans client/.env, ou serveur pas à jour)
    if (typeof res.data === 'string') {
        throw new Error(`Le serveur du tracker (${api.defaults.baseURL || 'adresse vide'}) ne connaît pas cette page : vérifie REACT_APP_API_URL dans client/.env et que son serveur est à jour.`);
    }
    return res.data;
}

/** Client lié à un projet : p.get('/users', { page }) → /projects/primestation/users?page=… */
export const projectApi = (project) => ({
    project,
    get: (path, params) => call('get', `/projects/${project}${path}`, params),
    post: (path, body = {}) => call('post', `/projects/${project}${path}`, body),
    put: (path, body = {}) => call('put', `/projects/${project}${path}`, body),
    del: (path, body) => call('delete', `/projects/${project}${path}`, body),
});
